/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TypographyItemDto = {
    /**
     * Font family
     */
    fontFamily?: string;
    /**
     * Font weight
     */
    fontWeight?: number;
    /**
     * Font size
     */
    fontSize?: string;
    /**
     * Line height
     */
    lineHeight?: number;
    /**
     * Letter spacing
     */
    letterSpacing?: string;
    /**
     * Text transform
     */
    textTransform?: TypographyItemDto.textTransform;
    /**
     * Text color
     */
    color?: string;
};
export namespace TypographyItemDto {
    /**
     * Text transform
     */
    export enum textTransform {
        NONE = 'none',
        UPPERCASE = 'uppercase',
        LOWERCASE = 'lowercase',
        CAPITALIZE = 'capitalize',
    }
}

